import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoPagoService } from 'src/app/services/movimiento-pago.service';
import { SaldoDocumentoService } from 'src/app/services/saldo-documento.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarVendedorComponent } from '../../shared/modal-seleccionar-vendedor/modal-seleccionar-vendedor.component';
import * as _ from 'lodash'

@Component({
  selector: 'app-clientes-morosos',
  templateUrl: './clientes-morosos.component.html',
  styleUrls: ['./clientes-morosos.component.scss'],
  providers: [SecurityService],
})
export class ClientesMorososComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarVendedorComponent, { static: true }) modalSeleccionarVendedor: ModalSeleccionarVendedorComponent

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  private currentPayload: any = null
  private inputParams: any = null
  clienteSeleccionado: any = null
  vendedorSeleccionado: any = null
  listaRegistros: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  enableVendedorInputs: boolean = true
  enableClienteInputs: boolean = true

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private rutService: RutService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService,
    private saldoDocumentoService: SaldoDocumentoService,
    private fileDownloadService: FileDownloadService,
  ) {
    this.log = this.clog.log('CARTOLA-CLIENTE')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10

    this.createForms()
    this.formChangesSubscriptions()
    this.formHeader.get('todosClientes').setValue(true);
    this.formHeader.get('todosVendedores').setValue(true);

  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
      rutCliente: [''],
      todosClientes: [false],
      rutVendedor: [null],
      todosVendedores: [false],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.log('rutCliente change', rutCliente)
        this.modalSeleccionarCliente.searchByRut(rutCliente)
      })

    this.formHeader.get("rutVendedor").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutVendedor: string) => {
        this.modalSeleccionarVendedor.searchByRut(rutVendedor)
      })

    /********* MODAL CLIENTE *********/
    this.formHeader.get("todosClientes").valueChanges
      .subscribe((todosClientes: string) => {
        this.enableClienteInputs = !todosClientes
      })

    /********* MODAL VENDEDOR *********/
    this.formHeader.get("todosVendedores").valueChanges
      .subscribe((todosVendedores: string) => {
        this.enableVendedorInputs = !todosVendedores
      })
  }


  /********* MODAL CLIENTE *********/
  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data, origen }) {
    this.clienteSeleccionado = data
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut)
    this.log('this.clienteSeleccionado', this.clienteSeleccionado)
    this.formHeader.get('rutCliente').setValue(this.clienteSeleccionado.rutFormato)
    this.formHeader.get('todosVendedores').setValue(true);
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
  }
  /********* MODAL CLIENTE *********/


  /********* MODAL VENDEDOR *********/
  abrirModalSeleccionarVendedor() {
    this.modalSeleccionarVendedor.show()
  }

  onVendedorSeleccionado({ data }) {
    this.vendedorSeleccionado = data
    this.formHeader.get('rutVendedor').setValue(this.rutService.AgregarDV(this.vendedorSeleccionado.rut))
    this.formHeader.get('todosClientes').setValue(true);

  }

  onVendedorNoEncontrado() {
    this.vendedorSeleccionado = null
  }
  /********* MODAL VENDEDOR *********/


  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber

    this.listaRegistros = null

    let valid: Boolean = true

    if (this.enableClienteInputs && !this.clienteSeleccionado) {
      this.toastrService.error('Seleccione cliente')
      valid = false
    }

    if (this.enableVendedorInputs && !this.vendedorSeleccionado) {
      this.toastrService.error('Seleccione vendedor')
      valid = false
    }

    if (!valid)
      return

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      fechaInicio: this.formHeader.get('fechaDesde').value,
      fechaTermino: this.formHeader.get('fechaHasta').value,
      cliente_proveedor_rut: (!this.formHeader.get('todosClientes').value && this.clienteSeleccionado) ? this.clienteSeleccionado.rut : 0,
      vendedor_codigo: (!this.formHeader.get('todosVendedores').value && this.vendedorSeleccionado) ? this.vendedorSeleccionado.codigo : 0,
      todosClientes: this.formHeader.get('todosClientes').value,
      todosVendedores: this.formHeader.get('todosVendedores').value,
      generaExcel: false,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.currentPayload = _.cloneDeep(inputParams)

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.saldoDocumentoService.obtenerClientesMorosos(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaRegistros = registros
      this.listaRegistros = registros
      this.listaRegistros.map(registro => {
        registro.rutFormato = this.rutService.AgregarDV(registro.cliente_proveedor_rut)
      })

      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  exportarExcel() {
    const inputParams = _.cloneDeep(this.currentPayload)
    inputParams.generaExcel = true
    delete inputParams.paginaActual
    delete inputParams.cantidadRegistrosPorPagina

    this.log('XLS', JSON.stringify(inputParams))

    this.saldoDocumentoService.obtenerClientesMorososExcel(inputParams, ({ mensajes, respuesta }) => {

      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      this.log('excel respuesta', respuesta)
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].nombreArchivoExcel)
    })
  }

}
